import { Button } from "@mui/material";
import React, { useRef } from "react";
import Webcam from "react-webcam";
import moment from "moment";

const ImageUploadWebcam = ({ onCapture }) => {
  const webcamRef = useRef(null);

  const takePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    const byteCharacters = atob(imageSrc.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    let fileName = `${moment(new Date()).format("YYYYMMDDHHmmss")}.jpg`;
    const blob = new Blob([byteArray], {
      type: "image/jpeg",
    });
    const file = new File([blob], fileName, {
      type: "image/jpeg",
    });
    onCapture(file);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
      }}
    >
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={{ facingMode: "environment" }}
        style={{ objectFit: "contain" }}
      />
      <Button
        variant="contained"
        color="primary"
        style={{
          position: "absolute",
          bottom: "40px",
          left: "50%",
          transform: "translate(-50%, 0)",
        }}
        onClick={takePhoto}
      >
        写真を撮る
      </Button>
    </div>
  );
};

export default ImageUploadWebcam;
